module.exports = [{"id":1,"src":"./images/hobby1.jpg","text":"Devoting my time to my family"},{"id":2,"src":"./images/hobby2.jpg","text":"Admiring the distant places on my bike"},{"id":3,"src":"./images/hobby3.jpg","text":"Watching the world from above with my drone"},{"id":4,"src":"./images/hobby4.jpg","text":"Exploring the starry sky"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/hobbies.json
// module id = 253
// module chunks = 0